export default "__VITE_ASSET__DnnGp0Jm__"